var $888756784d832bd7$exports = {};
$888756784d832bd7$exports = {
  "close": "Fermer",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " notification");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " notifications");
      }
    }), ".");
  }
};
export { $888756784d832bd7$exports as default };